import { render, staticRenderFns } from "./Riepilogo.vue?vue&type=template&id=27c13f73&"
import script from "./Riepilogo.vue?vue&type=script&lang=js&"
export * from "./Riepilogo.vue?vue&type=script&lang=js&"
import style0 from "./Riepilogo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports